import React from 'react'
import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import TCAIREMResourceRow from './TCAIREMResourceRow'
import { TCAIREMStyle } from '../styles'

/**
 * Collapsible band for one T-CAIREM resource type tag (e.g. "Code Notebooks").
 * Sections are admin-driven: one exists per TCAIREMResourceTypeTag with matches.
 */
const TCAIREMSection = ({ tagName, resources, expanded, onToggle, highlightedId }) => {
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            onToggle()
        }
    }

    return (
        <Box sx={TCAIREMStyle.section}>
            <Box
                sx={TCAIREMStyle.sectionHeader}
                onClick={onToggle}
                onKeyDown={handleKeyDown}
                role='button'
                tabIndex={0}
                aria-expanded={expanded}
            >
                <Typography variant='h6'>{`${tagName} (${resources.length})`}</Typography>
                <ExpandMoreIcon sx={{
                    transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s',
                }} />
            </Box>
            {/* Unmount collapsed rows: an open video player must stop when its
                section collapses, and collapsed sections must not fetch poster
                images (issue #288's no-eager-requests rule). */}
            <Collapse in={expanded} mountOnEnter unmountOnExit>
                {resources.map((resource, index) => (
                    <TCAIREMResourceRow
                        key={resource.id}
                        resource={resource}
                        alternate={index % 2 === 1}
                        highlighted={resource.id === highlightedId}
                    />
                ))}
            </Collapse>
        </Box>
    )
}

export default TCAIREMSection
